<template>
  <div id="II">
    <el-card class="IIcard">
        <div class="IItitleimg " v-html="indicator.info.content"></div>
      <img :src="serverUrl+'/' +indicator.info.img" id="IIimg" />
    </el-card>
    <el-card class="IIcard">
      
      <div class="IItitle">Параметры индикатора:</div>
      <ul>
        <li v-for="(item, i) in indicator.info.params" :key="i">
          {{ item }}
        </li>
      </ul>
    </el-card>
    <el-card class="IIcard">
      <div class="IItitle" v-html="indicator.info.paramsInfoContent"></div>
      <ul>
        <li v-for="(item2, i2) in indicator.info.paramsInfo" :key="i2">
          {{ item2 }}
        </li>
      </ul>
    </el-card>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { useMyStorage } from "@/store/global";
export default defineComponent({
  props: {
    idi: {
      type: Number,
      requred: true,
    },
  },
  name: "IndicatorInfo",
  setup(props) {
    const store = useMyStorage();
    const indicator = reactive(store.indicators[props.idi]);
    const serverUrl=store.ServerUrl;
    return { indicator, serverUrl };
  },
});
</script>
<style lang="scss">
#II {
  #IIimg {
    width: 100%;
  }
  .LLIprogram {
    .LLIprogramcard {
      width: 45%;
      margin: 2%;
      display: inline-block;
      height: 140px;
    }
  }
  .IIcard {
    width: 100%;
    margin-bottom: 15px;
    .IItitleimg{
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      margin-bottom: 15px;
      padding: 5px 30px;
    }
    .IItitle {
      //   font-family: Montserrat;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      margin-bottom: 15px;
    }
    li {
      list-style-image: url(~@/assets/images/arrow-right.svg);
      font-size: 20px;
      margin-bottom: 5px;
    }
  }

  .LLIgoals {
    margin-left: 40px;
    margin-bottom: 30px;
    .LLIgoalcard {
      display: inline-block;
      width: 250px;
      height: 250px;
      margin: 10px;
    }
  }
}
</style>
